import request from '@/plugin/axios'
import QS from 'qs'
import store from '@/store/index'

export function jsonPostRequest (url, param) {
  return request({
    url: url,
    method: 'post',
    data: param,
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
      Language: store.getters.currentLanguage
    },
    transformRequest: [
      function () {
        return JSON.stringify(param)
      }
    ]
  })
}

export function formPostRequest (url, param) {
  return request({
    url: url,
    method: 'post',
    contentType: 'form',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Language: store.getters.currentLanguage
    },
    data: param,
    transformRequest: [
      function () {
        return QS.stringify(param)
      }
    ]
  })
}
